import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=0c36f626&scoped=true"
import script from "./Button.ts?vue&type=script&lang=ts&external"
export * from "./Button.ts?vue&type=script&lang=ts&external"
import style0 from "./Button.vue?vue&type=style&index=0&id=0c36f626&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36f626",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c36f626')) {
      api.createRecord('0c36f626', component.options)
    } else {
      api.reload('0c36f626', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=0c36f626&scoped=true", function () {
      api.rerender('0c36f626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Uploader/components/Button/Button.vue"
export default component.exports